import { Component, OnDestroy, OnInit } from '@angular/core';
import { CompositeFilterDescriptor, FilterDescriptor, process, State } from '@progress/kendo-data-query';
import { Subscription } from 'rxjs';
import { gridData as sampleGridData } from './sample-grid-data';

// Kendo Imports
import { InputsModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { DataStateChangeEvent, GridDataResult, GridModule } from '@progress/kendo-angular-grid';
import { DropDownFilterSettings, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LayoutModule, Orientation, PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import {
	FormBuilder,
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
	UntypedFormControl,
	ValidatorFn,
	Validators,
} from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { SharedModule } from '@app/shared/shared.module';
import { SVGIcon, bellIcon, calendarIcon, folderIcon, heartIcon, userIcon } from '@progress/kendo-svg-icons';
import { IconsModule, SVGIconModule } from '@progress/kendo-angular-icons';
import { CommonModule } from '@angular/common';
import { DateInputComponent, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { GridSettings } from '@app/shared/interface/grid-settings.interface';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@Component({
	selector: 'app-kitchen-sink',
	templateUrl: './kitchen-sink.component.html',
	styleUrl: './kitchen-sink.component.scss',
})
export class KitchenSinkComponent {
	constructor(private formBuilder: FormBuilder) {
		this.form = new FormGroup({
			textbox: new FormControl(),
		});
	}
	loading: boolean;
	public selectedItemIds: any[] = [];
	public form: FormGroup;
	public min: Date = new Date(1917, 0, 1);
	public max: Date = new Date(2020, 4, 31);
	public sizes = [10, 20, 50];
	public registerForm: FormGroup = new FormGroup({
		firstName: new FormControl(),
		lastName: new FormControl(),
		birthDate: new FormControl(new Date(2000, 10, 10)),
		email: new FormControl('', Validators.email),
		acceptNews: new FormControl(),
		vehicle: new FormControl(2),
	});
	public noDataFoundGridText = 'Enter a search term above to see results.';
	public orientation: Orientation = 'horizontal';
	public userSvg: SVGIcon = userIcon;
	public lindseyAvatar = 'https://demos.telerik.com/blazor-ui/images/stack-layout/avatar1.jpg';
	public vincenzoAvatar = 'https://demos.telerik.com/blazor-ui/images/stack-layout/avatar2.jpg';
	public marissaAvatar = 'https://demos.telerik.com/blazor-ui/images/stack-layout/avatar3.jpg';

	public lindseyImage = 'https://demos.telerik.com/blazor-ui/images/stack-layout/dog1.jpg';
	public vincenzoImage = 'https://demos.telerik.com/blazor-ui/images/stack-layout/summer.jpg';
	public marissaImage = 'https://demos.telerik.com/blazor-ui/images/stack-layout/dog2.jpg';
	public calendarIcon: SVGIcon = calendarIcon;
	public heartIcon: SVGIcon = heartIcon;
	public bellIcon: SVGIcon = bellIcon;
	public vehicles: Array<{ text: string; value: number }> = [
		{ text: 'Car', value: 1 },
		{ text: 'Bus', value: 2 },
		{ text: 'Boat', value: 3 },
		{ text: 'Airplane', value: 4 },
	];
	languages = [
		{ text: 'English', value: 'en' },
		{ text: 'Spanish', value: 'es' },
		{ text: 'French', value: 'fr' },
	];
	selectedLanguage = 'en';

	data = [{ text: 'My Profile' }, { text: 'Friend Requests' }, { text: 'Account Settings' }, { text: 'Support' }, { text: 'Log Out' }];
	public vehicle: { text: string; value: number };
	public submitForm(): void {
		this.registerForm.markAllAsTouched();
	}

	public clearForm(): void {
		this.registerForm.reset();
	}
	public folderIcon: SVGIcon = folderIcon;
	public range = { start: new Date(2018, 10, 10), end: new Date(2018, 10, 20) };
	public dialogOpened = false;
	public windowOpened = false;

	public close(component: string): void {
		this[component + 'Opened'] = false;
	}
	public mapGridSettings(gridSettings: GridSettings): GridSettings {
		const state = gridSettings.state;
		const settings = {
			state,
			columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex),
		};

		settings.state.filter.filters.forEach((x) => {
			const filterValue = x as FilterDescriptor;
			if (filterValue.field === 'ProductID') {
				// THe date is deserialized as a string, so we need to parse it back into a date
				// so that the Kendo filter handles it correctly
				filterValue.value = new Date(filterValue.value);
			}
		});
		return settings;
	}
	private hasGridFilters = () =>
		!this.gridSettings || !this.gridSettings.state.filter ? false : this.gridSettings.state.filter.filters.length > 0;
	public open(component: string): void {
		this[component + 'Opened'] = true;
	}

	public action(status: string): void {
		this.dialogOpened = false;
	}
	thumbnailSrc = 'https://www.telerik.com/kendo-angular-ui-develop/components/layout/card/assets/rila.jpg';

	/* 
  add intial employees then append second list on typing in control for multi select  
  EmployeeSearchAssignedTo even  you can change data assigned to multi select 
  */
	public employeesAssignedTo: any[] = [
		{ textField: 'firstname1 lastname1', AssignedToId: '1' },
		{ textField: 'firstname2 lastname2', AssignedToId: '2' },
		{ textField: 'firstname3 lastname3', AssignedToId: '3' },
		{ textField: 'firstname4 lastname4', AssignedToId: '4' },
	];

	public employeesAssignedTo1: any[] = [
		{ textField: 'firstname5 lastname5', AssignedToId: '5' },
		{ textField: 'firstname6 lastname6', AssignedToId: '6' },
		{ textField: 'firstname7 lastname7', AssignedToId: '7' },
		{ textField: 'firstname8 lastname8', AssignedToId: '8' },
	];
	public ngOnInit(): void {
		this.initDatePicker();
		this.initAutoComplete();
		this.initTextbox();
		this.initTextarea();
		if (this.hasGridFilters()) {
			this.noDataFoundGridText = 'Enter a search term above to see results.';
		}
	}

	public ngOnDestroy(): void {
		this.destroyDatePicker();
		this.destroyAutoComplete();
		this.destroyTextbox();
		this.destroyTextarea();
	}
	public toggleOrientation(orientation: Orientation): void {
		this.orientation = orientation;
	}
	/**
	 * Chip bindings
	 */
	public chips = [
		{
			label: 'None',
			icon: null,
			type: 'none',
			removable: true,
		},
		{
			label: 'Info',
			icon: 'information',
			type: 'info',
			removable: true,
		},
		{
			label: 'Success',
			icon: 'check-outline',
			type: 'success',
			removable: true,
		},
		{
			label: 'Warning',
			icon: 'warning',
			type: 'warning',
			removable: true,
		},
		{
			label: 'Error',
			icon: 'warning',
			type: 'error',
			removable: true,
		},
	];

	/**
	 * Date picker bindings
	 */
	public now = new Date();

	private get today(): Date {
		const d = new Date();
		d.setHours(0, 0, 0, 0);
		return d;
	}

	public datePickerValue: UntypedFormControl = new UntypedFormControl(this.today);
	public datePickerRequired: UntypedFormControl = new UntypedFormControl(true);
	public datePickerRequiredSubscription: Subscription;

	private get datePickerValidators(): ValidatorFn[] {
		const v: ValidatorFn[] = [
			(control) => {
				if (!control.value || (<Date>control.value).getTime() <= this.now.getTime()) return null;
				return { maxdate: 'The date exceeds the maximum date allowed.' };
			},
		];
		if (this.datePickerRequired.value === true) v.push(Validators.required);
		return v;
	}

	private setDatePickerValidators(): void {
		this.datePickerValue.setValidators(this.datePickerValidators);
		this.datePickerValue.updateValueAndValidity();
	}

	private initDatePicker(): void {
		this.setDatePickerValidators();
		this.datePickerRequiredSubscription = this.datePickerRequired.valueChanges.subscribe(() => {
			this.setDatePickerValidators();
		});
	}
	// event from multi select when you type something it will add second list
	EmployeeSearchAssignedTo($event) {
		// here you can filer based on $event.search
		this.employeesAssignedTo = this.employeesAssignedTo.concat(this.employeesAssignedTo1);
	}

	private destroyDatePicker(): void {
		this.datePickerRequiredSubscription.unsubscribe();
	}

	/**
	 * Autocomplete bindings
	 */
	public autoCompleteListItems: string[] = [
		'Albania',
		'Andorra',
		'Armenia',
		'Austria',
		'Azerbaijan',
		'Belarus',
		'Belgium',
		'Bosnia & Herzegovina',
		'Bulgaria',
		'Croatia',
		'Cyprus',
		'Czech Republic',
		'Denmark',
		'Estonia',
		'Finland',
		'France',
		'Georgia',
		'Germany',
		'Greece',
		'Hungary',
		'Iceland',
		'Ireland',
		'Italy',
		'Kosovo',
		'Latvia',
		'Liechtenstein',
		'Lithuania',
		'Luxembourg',
		'Macedonia',
		'Malta',
		'Moldova',
		'Monaco',
		'Montenegro',
		'Netherlands',
		'Norway',
		'Poland',
		'Portugal',
		'Romania',
		'Russia',
		'San Marino',
		'Serbia',
		'Slovakia',
		'Slovenia',
		'Spain',
		'Sweden',
		'Switzerland',
		'Turkey',
		'Ukraine',
		'United Kingdom',
		'Vatican City',
	];

	public autoCompleteValue: UntypedFormControl = new UntypedFormControl(null);
	public autoCompleteRequired: UntypedFormControl = new UntypedFormControl(true);
	private autoCompleteRequiredSubscription: Subscription;

	public autoCompleteFilterSettings: DropDownFilterSettings = {
		caseSensitive: false,
		operator: 'contains',
	};

	private get autoCompleteValidators(): ValidatorFn[] {
		const v: ValidatorFn[] = [
			(control) => {
				if (!control.value || this.autoCompleteListItems.includes(control.value)) return null;
				return { includes: 'The data collection does not include the current control value.' };
			},
		];
		if (this.autoCompleteRequired.value === true) v.push(Validators.required);
		return v;
	}

	private setAutoCompleteValidators(): void {
		this.autoCompleteValue.setValidators(this.autoCompleteValidators);
		this.autoCompleteValue.updateValueAndValidity();
	}

	private initAutoComplete(): void {
		this.setAutoCompleteValidators();
		this.autoCompleteRequiredSubscription = this.autoCompleteRequired.valueChanges.subscribe(() => {
			this.setAutoCompleteValidators();
		});
	}

	private destroyAutoComplete(): void {
		this.autoCompleteRequiredSubscription.unsubscribe();
	}

	/**
	 * Textbox Bindings
	 */

	public textboxRequired: UntypedFormControl = new UntypedFormControl(true);
	public textboxValue: UntypedFormControl = new UntypedFormControl('80026');
	public textboxRequiredSubscription: Subscription;

	private get textboxValidators(): ValidatorFn[] {
		const v = [Validators.pattern(/^\d{5}$/)];
		if (this.textboxRequired.value === true) v.push(Validators.required);
		return v;
	}

	private setTextboxValidators(): void {
		this.textboxValue.setValidators(this.textboxValidators);
		this.textboxValue.updateValueAndValidity();
	}

	private initTextbox(): void {
		this.setTextboxValidators();
		this.textboxRequiredSubscription = this.textboxRequired.valueChanges.subscribe(() => {
			this.setTextboxValidators();
		});
	}

	private destroyTextbox(): void {
		this.textboxRequiredSubscription.unsubscribe();
	}

	/**
	 * Textarea Bindings
	 */

	private readonly textareaContent: string = `Spicy jalapeno bacon ipsum dolor amet duis porchetta corned beef, aliqua jowl quis dolore consequat lorem. Shank consectetur 
    sausage aliqua laborum leberkas sint. Salami kevin ut hamburger commodo jerky biltong incididunt ut velit. Irure ex enim rump, 
    anim jerky consectetur fatback pig boudin cillum jowl proident. Non esse pork loin anim pork belly.`;

	public textareaRequired: UntypedFormControl = new UntypedFormControl(true);
	public textareaValue: UntypedFormControl = new UntypedFormControl(this.textareaContent.replace(/\s+/g, ' '));
	public textareaRequiredSubscription: Subscription;

	private get textareaValidators(): ValidatorFn[] {
		const v = [];
		if (this.textareaRequired.value === true) v.push(Validators.required);
		return v;
	}

	private setTextareaValidators(): void {
		this.textareaValue.setValidators(this.textareaValidators);
		this.textareaValue.updateValueAndValidity();
	}

	private initTextarea(): void {
		this.setTextareaValidators();
		this.textareaRequiredSubscription = this.textareaRequired.valueChanges.subscribe(() => {
			this.setTextareaValidators();
		});
	}

	private destroyTextarea(): void {
		this.textareaRequiredSubscription.unsubscribe();
	}

	/**
	 * Grid Bindings
	 */
	defaultFilter = {
		field: 'ProductID',
		operator: 'eq',
		value: true,
		ignoreCase: false,
	};
	gridSettings: GridSettings = {
		state: {
			skip: 0,
			take: 10,

			sort: [
				{
					field: 'ProductID',
					dir: 'asc',
				},
			],
		},
		columnsConfig: [
			{
				field: 'ProductID',
				title: 'ProductID',
				filterable: true,
				width: 300,
				locked: true,
				id: 'grid_Items_ProductIDFilter',
				show: false,
				hidden: false,
				sortable: true,
				minResizableWidth: '200',
			},
			{
				field: 'ProductName',
				title: 'Product Name',
				filterable: true,
				width: 200,
				locked: false,
				id: 'grid_Items_ProductNameFilter',
				show: false,
				hidden: false,
				sortable: true,
				minResizableWidth: '200',
			},
			{
				field: 'FirstOrderedOn',
				title: 'FirstOrderedOn',
				filterable: true,
				width: 300,
				locked: false,
				id: 'grid_Items_FirstOrderedOnFilter',
				show: false,
				filter: 'date',
				class: 'k-grid-ignore-click',
				hidden: false,
				sortable: true,
				minResizableWidth: '200',
			},
			{
				field: 'UnitPrice',
				title: 'UnitPrice',
				filterable: true,
				width: 250,
				locked: false,
				id: 'grid_Items_UnitPriceFilter',
				show: true,
				hidden: false,
				sortable: true,
				minResizableWidth: '200',
			},
			{
				field: 'Discontinued',
				title: 'Discontinued',
				filterable: true,
				width: 250,
				locked: false,
				id: 'grid_Items_DiscontinuedFilter',
				show: true,
				hidden: false,
				sortable: true,
				minResizableWidth: '150',
			},
			{
				field: 'LastOrderedOn',
				title: 'LastOrderedOn',
				filterable: true,
				width: 300,
				locked: false,
				id: 'grid_Items_LastOrderedOnFilter',
				show: true,
				filter: 'date',
				class: 'k-grid-ignore-click',
				hidden: false,
				sortable: true,
				minResizableWidth: '150',
			},
			{
				field: 'AssignedTo',
				title: 'AssignedTo',
				filterable: true,
				width: 200,
				locked: false,
				id: 'grid_Items_AssignedToFilter',
				show: true,
				hidden: false,

				sortable: true,
				minResizableWidth: '150',
			},
		],
	};
	public gridState: State = {
		skip: 0,
		take: 5,
		filter: {
			logic: 'and',
			filters: [{ field: 'ProductName', operator: 'contains', value: '' }],
		},
	};

	public gridData: GridDataResult = process(sampleGridData, this.gridSettings.state);

	public dataStateChange(state: DataStateChangeEvent): void {
		this.gridSettings.state = state;
		this.gridData = process(sampleGridData, this.gridSettings.state);
		this.noDataFoundGridText = 'No records available.';
	}
	public onReorder(e: any): void {
		const reorderedColumn = this.gridSettings.columnsConfig.splice(e.oldIndex, 1);
		this.gridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
		//this.saveGrid();
	}

	public onResize(e: any): void {
		e.forEach((item) => {
			this.gridSettings.columnsConfig.find((col) => col.field === item.column.field).width = item.newWidth;
		});

		//this.saveGrid();
	}

	public onVisibilityChange(e: any): void {
		e.columns.forEach((column) => {
			this.gridSettings.columnsConfig.find((col) => col.field === column.field).hidden = column.hidden;
		});

		//this.saveGrid();
	}
	public filterChange(filter: CompositeFilterDescriptor): void {
		this.gridSettings.state.filter = filter;
		//this.saveGrid();
	}
	/**
	 * Panel Bar gridData
	 */
	public expandMode: PanelBarExpandMode = PanelBarExpandMode.Single;

	/**
	 * Tooltip Bindings
	 */
	public tooltipPosition: UntypedFormControl = new UntypedFormControl('top');
}
